<template>
  <div>
    <world-nav/>
    <b-form-group id="quest" label="メイン行動" class="form">
      <select-list
        :items="actionList"
        :fields="[
          { key:'name', label:'行動名', filterType:'string', filterKey:'label' },
          { key:'area', label:'エリア', filterType:'string', filterKey(v){ return innerValue.area[v.location].name } },
          { key:'ctrl', label:'' }
        ]"
        :perPage="10"
        tableKey='RID'
        :selectable="true"
        tableClass='action-list'
      >
        <template v-slot:cell(area)="row">
          <div>{{ innerValue.area[row.item.location].name }}</div>
        </template>
        <template v-slot:cell(name)="row">
          <router-link :to="{ path:`/quest/${row.item.location}/${row.item.RID}` }">
            {{ row.item.label }}<font-awesome-icon icon="pen" class="icon fa-sx" />
          </router-link>
        </template>
        <template v-slot:cell(ctrl)="row">
          <a @click="$delete(innerValue.area[row.item.location].quest, row.item.RID)">
            <font-awesome-icon icon="times" class="icon fa-1x m-1" />
          </a>
        </template>
      </select-list>
    </b-form-group>
  </div>
</template>

<script>
// import store from '@/store'
import WorldNav from '@/components/WorldNav'
import SelectList from '@/components/SelectList'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
export default {
  components: {
    WorldNav,
    SelectList
  },
  mixins: [mixinPlayer],
  computed: {
    // TODO メイン行動一覧
    actionList () {
      let list = []
      _.values(this.innerValue.area).forEach((area)=>{
        list = list.concat(_.values(area.quest))
      })
      return list
    }
  },
  props: {
    value: Object,
    postMessage: Object,
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  methods: {
    // addMainAction () {
    //   let id = '@'+_.uniqueId()
    //   this.$set(this.innerValue.area[this.detailKey].quest, id ,{
    //     code: [{
    //       call: 'totototo.dice',
    //       arguments: {
    //         status: "",
    //         up: "",
    //         target: 0
    //       }
    //     }],
    //     prepareCode:[],
    //     condition:[],
    //     label: "散歩する",
    //     location: this.detailKey
    //   })
    //   this.$router.push({ path:`/quest/${this.detailKey}/${id}` })
    // },
  },
  created () {
    this.$emit('changePlayer', 'n-player')
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.ctl {
  width: 40px;
}
</style>
